export default __webpack_public_path__ + "static/media/img-0372-ovato-nation-half-face.ae538cc5.png";